/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import {
  FormTemplate,
  FormTemplateSection,
  FormTemplateOption,
  FormTemplateFieldMap,
} from 'data/template/template.types';
import { XtpXdpConnection } from 'data/xtp-xdp-connection/xtp-xdp-connection.types';
import { Xtp } from 'data/xtp/xtp.types';
import { Xdp } from 'data/xdp/xdp.types';

export type ListenersIpAddressPortsType = {
  [key:string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'edit') {
    (clonedTemplate.main as FormTemplateSection).fields.name.readOnly = true;
    (clonedTemplate.main as FormTemplateSection).fields.ipduid.readOnly = true;
    (clonedTemplate.main as FormTemplateSection).fields.lbid.readOnly = true;
  } else if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }

  return clonedTemplate;
}

export function adaptTemplateOptions(
  template: FormTemplate | undefined,
  xtpXdpConnection?: XtpXdpConnection,
): FormTemplate | undefined {
  if (template == null) {
    return template;
  }

  return cloneDeep(template);
}

function setAllFieldsAsReadOnlyExcludingFields(template: FormTemplate, excludingFields: string[]) {
  Object.entries(template).forEach(([_templateKey, templateEntry]) => {
    if (typeof templateEntry === 'string') {
      return;
    }
    Object.entries(templateEntry.fields).forEach(([fieldKey, fieldEntry]) => {
      if (!excludingFields.includes(fieldKey)) {
        fieldEntry.readOnly = true;
      }
    });
  });
}

export function adaptXtpXdpConnectionTemplate(
  template: FormTemplate,
  xdps: Xdp[],
  xtps: Xtp[],
  xtpXdpConnection?: XtpXdpConnection,
  ): FormTemplate {

  const clonedTemplate = cloneDeep(template);
  clonedTemplate.key = Date.now().toString();
  clonedTemplate.formId = Date.now().toString();

  setOptions((clonedTemplate.main as FormTemplateSection)?.fields, 'ipduid', getXdpOptions(xdps), true);
  setOptions((clonedTemplate.main as FormTemplateSection)?.fields, 'lbid', getXtpOptions(xtps), false);

  if (xtpXdpConnection != null) {
    Object.keys(xtpXdpConnection.protocols).forEach((protocol) => {
      const protocolValue = (clonedTemplate.protocol as FormTemplateSection).fields[protocol.toLowerCase()];
      if (protocolValue) {
        protocolValue.initial = true;
      }
    });
  }

  return clonedTemplate;
}

function getXdpOptions(xdps: Xdp[]) {
  return xdps.map((item) => ({
    value: item.ipduId,
    label: `${item.ipduId} [${item.ipAddr}]`
  }))
}

function getXtpOptions(xtps: Xtp[]) {
  return xtps.map((item) => ({
    value: item.lbId,
    label: `${item.lbId} [${item.ipAddr}]`
  }))
}

function setOptions(
  fieldMap: FormTemplateFieldMap,
  field: string,
  options: FormTemplateOption[],
  addEmptyPLaceHolder: boolean,
) {
  if (addEmptyPLaceHolder) {
    fieldMap[field].options = [
      { label: 'Select a value', value: '' },
      ...options
    ];
  } else {
    fieldMap[field].options = [...options];
  }
}

export function adaptFormData(
  data: XtpXdpConnection,
): XtpXdpConnection {

  return cloneDeep(data);
}

export function adaptXdpFormData(
  xtpXdpConnection: XtpXdpConnection,
): XtpXdpConnection {

  const clonedXdp = cloneDeep(xtpXdpConnection);

  return clonedXdp;
}

export function getNextIdId(
  xtpXdpConnection: XtpXdpConnection,
): number {
  const { protocols } = cloneDeep(xtpXdpConnection);

  const [last] = Object
    .keys(protocols)
    .map((key) => Number(protocols?.[key]?.ifid))
    .sort()
    .reverse();
  return last;
}
